export class UserRegistrationFilter {
    constructor() {
    }

}